import { render, staticRenderFns } from "./DikidiLink.vue?vue&type=template&id=aa109cfa&scoped=true"
import script from "./DikidiLink.vue?vue&type=script&lang=js"
export * from "./DikidiLink.vue?vue&type=script&lang=js"
import style0 from "./DikidiLink.vue?vue&type=style&index=0&id=aa109cfa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa109cfa",
  null
  
)

export default component.exports